<ng-content select="app-versatile-list-header"></ng-content>
<ng-content select="app-versatile-list-body"></ng-content>
<ng-content select="app-versatile-list-footer"></ng-content>
